import React from 'react';
import { Grid, List } from 'semantic-ui-react';

const Roadmap = () => {
  return (
    <Grid centered>
      <Grid.Column>
        <List ordered size="big">
          <List.Item>
            <List.Header>Live Movement Indicators</List.Header>
            <List.List>
              <List.Item>Bittrex</List.Item>
              <List.Item>Poloniex</List.Item>
              <List.Item>Binance</List.Item>
            </List.List>
          </List.Item>
          <List.Item>
            <List.Header>News</List.Header>
            <List.List>
              <List.Item>Twitter</List.Item>
              <List.Item>Telegram</List.Item>
              <List.Item>Reddit</List.Item>
            </List.List>
          </List.Item>
          <List.Item>
            <List.Header>Alerts</List.Header>
            <List.List>
              <List.Item>SMS</List.Item>
              <List.Item>Email</List.Item>
              <List.Item>Telegram Push</List.Item>
              <List.Item>Slack Push</List.Item>
              <List.Item>WhatsApp Push</List.Item>
              <List.Item>WeChat Push</List.Item>
            </List.List>
          </List.Item>
          <List.Item>
            <List.Header>Mobile App</List.Header>
          </List.Item>
          <List.Item>
            <List.Header>Direct Trading</List.Header>
          </List.Item>
        </List>
      </Grid.Column>
    </Grid>
  );
};

export default Roadmap;



// WEBPACK FOOTER //
// ./src/components/Roadmap/index.jsx